import React from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getActivityLogByDateAction } from "store/actions"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import ActivityLogTable from "./table"
import { useState } from "react"
import { TimeFormat, DurationFormat } from "./column"
import ActivityLogFilter from "./filter"
import moment from "moment"
import MobileResize from "common/Resize/MobileResize"

const UserActivityLogScreen = ({}) => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}")
  const [formData, setFormData] = useState({
    userId: authUser.data.id,
    date: moment(new Date()).format("YYYY-MM-DD"),
  })
  const dispatch = useDispatch()

  const activityLogEntry = useSelector(state =>
    state?.workreport?.activitylogentry || []
  )

  useEffect(() => {
    getActivityLogByDate()
  }, [formData])

  const getActivityLogByDate = () => {
    dispatch(getActivityLogByDateAction(formData))
  }

  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Start Time",
        accessor: "startDate",
        disableFilters: true,
        width: 70,
        minWidth: 70,
        Cell: cellProps => {
          return <TimeFormat {...cellProps} />
        },
        dataType: "string",
      },
      {
        Header: "Application Title",
        accessor: "applicationtitle",
        disableFilters: true,
        Cell: row => {
          return (
            <div>
              {row?.cell?.value}
            </div>
          )
        },
        dataType: "string",
      },
      // {
      //   Header: "Category",
      //   accessor: "subCategoryname",
      //   disableFilters: true,
      //   Cell: row => {
      //     return (
      //       <div>
      //         {row?.cell?.value}
      //       </div>
      //     )
      //   },
      //   dataType: "string",
      // },
      {
        Header: "Duration",
        accessor: "durationinseconds",
        disableFilters: true,
        Cell: cellProps => {
          return <DurationFormat {...cellProps} />
        },
        dataType: "string",
        width: 60,
        minWidth: 60,
      },
      {
        Header: "Mouse Clicks",
        accessor: "mouseClicks",
        disableFilters: true,
        dataType: "number",
        width: 50,
        minWidth: 50,
      },
      {
        Header: "Key Press",
        accessor: "keyPress",
        disableFilters: true,
        dataType: "number",
        width: 50,
        minWidth: 50,
      },
    ]
    return result
  }, [activityLogEntry])

  const handleChangeFilter = (value, key) => {
    if (key === "date") {
      setFormData({ ...formData, [key]: moment(value).format("YYYY-MM-DD") })
    } else {
      setFormData({ ...formData, [key]: value.id })
    }
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth < 921)

  return <>
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col xs="12">
            <Breadcrumbs
              title={"View Activity Log"}
              breadcrumbItem={"View Activity Log"}
            />
            <Card>
              <CardBody className="table-mobileView">
                <ActivityLogFilter
                  handleChange={handleChangeFilter}
                  formData={formData}
                  authUser={authUser}
                />
                <MobileResize setIsMobile={setIsMobile}>
                  <ActivityLogTable
                    data={activityLogEntry}
                    columns={columns}
                    isMobile={isMobile}
                  />
                </MobileResize>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  </>
}

export default UserActivityLogScreen
